//

// Modal

import React, { useEffect, useRef, useState } from "react";
import { AllFormsUpperphoto, Applogo, profileLogo } from "../../../Routes/ImagePath";
import { DatePicker, Modal } from "antd";
import { Radio } from "react-feather";
import { useNavigate } from "react-router-dom";
import { Api_Url } from "../../../config/config";
import axios from "axios";
import { ErrorToast, SuccessToast } from "../../ToastComponent";
// import { MarketingActivityData } from "../../../Data/MarketingActivityjson";

export const MarketingModalPopup = ({ MarketDatFetchFunction, onClose }) => {
  const fileInputRef = useRef(null);

  const AllFileLoginData = async () => {
    try {
      const id = JSON.parse(sessionStorage.getItem("user"))?.id;
      // console.log("id", id)
      const response = await axios.get(`${Api_Url}api/v1/FileLogin/${id}`, {
        headers: {
          Authorization: `Bearer ${
            JSON.parse(sessionStorage.getItem("user")).accessToken
          }`,
        },
      });
      // console.log("response", response)
    } catch (error) {
      return error;
    }
  };

  useEffect(() => {
    AllFileLoginData();
  }, []);

  const [radioValue, setRadioValue] = useState(false);
  const [loading,setLoading] = useState(false)

  // const [location, setLocation] = useState(null);

  const [LocalFormData, setLocalFormData] = useState({
    BranchId: "",
    ActivityId: "",
    IsContactNumbercollected: false,
    Selfie: "",
    Location: "",
    Counts: "",
    Latitude: "",
    Longitude: "",
  });

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    setLocalFormData({ ...LocalFormData, Selfie: file });
  };

  const handleRadioChange = (e) => {
    setRadioValue(e.target.value === "true");
  };

  const handleDateChange = (date) => {
    setLocalFormData({ ...LocalFormData, VisitDate: date });
  };

  useEffect(() => {
    if ("geolocation" in navigator) {
      navigator.geolocation.getCurrentPosition(function (position) {
        const { latitude, longitude } = position.coords;
        setLocalFormData({
          ...LocalFormData,
          Latitude: latitude,
          Longitude: longitude,
        });
      });
    } else {
      alert("Geolocation is not supported by this browser.");
    }
  }, []);

  // console.log("location",location?.latitude)

  const HandleSubmit = async () => {
    // Validate required fields before setting the loading state
    if (!LocalFormData.BranchId) {
      ErrorToast("Branch is required");
      return;
    }
    if (!LocalFormData.ActivityId) {
      ErrorToast("Activity Type is required");
      return;
    }
    if (!LocalFormData.Selfie) {
      ErrorToast("A selfie or document is required");
      return;
    }
    if (!LocalFormData.Location) {
      ErrorToast("Location name is required");
      return;
    }
    if (
      LocalFormData.IsContactNumbercollected === true &&
      (!LocalFormData.Counts || LocalFormData.Counts <= 0)
    ) {
      ErrorToast("Please provide the count of contact numbers collected");
      return;
    }
  
    setLoading(true);
  
    const formData = new FormData();
    formData.append("BranchId", LocalFormData.BranchId);
    formData.append("ActivityId", LocalFormData.ActivityId);
    formData.append(
      "IsContactNumbercollected",
      LocalFormData.IsContactNumbercollected
    );
    formData.append("Selfie", LocalFormData.Selfie);
    formData.append("Location", LocalFormData.Location);
    formData.append("Counts", LocalFormData.Counts);
    formData.append("Latitude", LocalFormData.Latitude);
    formData.append("Longitude", LocalFormData.Longitude);
  
    try {
      const response = await axios.post(
        `${Api_Url}api/v1/MarketingActivity`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${
              JSON.parse(sessionStorage.getItem("user")).accessToken
            }`,
            "Content-Type": "multipart/form-data",
          },
        }
      );
      MarketDatFetchFunction();
      resetForm();
      SuccessToast("Marketing Activity Submitted Successfully");
      onClose();
    } catch (error) {
      ErrorToast("An Error Occurred while Submitting.");
      return error.message;
    }
  
    setLoading(false);
  };

  const resetForm = () => {
    setLocalFormData({
      BranchId: "",
      ActivityId: "",
      IsContactNumbercollected: false,
      Selfie: "",
      Location: "",
      Counts: "",
    });
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  };

  const [allbranch, setAllBranch] = useState("");

  const AllBranchName = async () => {
    try {
      const response = await axios.get(
        `${Api_Url}api/v1/Branch?PageNumber=1&PageSize=1000`,
        {
          headers: {
            Authorization: `Bearer ${
              JSON.parse(sessionStorage.getItem("user")).accessToken
            }`,
          },
        }
      );
      // console.log("response",response.data.data)
      setAllBranch(response.data.data);
    } catch (error) {
      return error;
    }
  };
  // console.log(allbranch)

  useEffect(() => {
    AllBranchName();
  }, []);

  const [MarketingActivityData, setMarketingActivityData] = useState([]);

  const handleMarketingActivity = async () => {
    try {
      const response = await axios.get(`${Api_Url}api/v1/Activity/all/12`, {
        headers: {
          Authorization: `Bearer ${
            JSON.parse(sessionStorage.getItem("user")).accessToken
          }`,
        },
      });
      // console.log("object",response.data.data)
      setMarketingActivityData(response.data.data);
    } catch (error) {
      return error.message;
    }
  };

  useEffect(() => {
    handleMarketingActivity();
  }, []);

  return (
    <>
      <Modal
        title={<h4>Marketing Activity</h4>}
        open={true}
        onOk={onClose}
        onCancel={onClose}
        footer={[
          <div
            className="d-flex justify-content-between align-items-center"
            key="footer"
          >
            <button className="btn btn-danger submit-btn" onClick={onClose}>
              Cancel
            </button>
            <button
              className="btn btn-primary submit-btn"
              onClick={HandleSubmit}
              disabled={loading}
            >
              {loading ? "Submitting..." : "Submit"}
            </button>
          </div>,
        ]}
        width={600}
        maskClosable={false}
        closeIcon={<span style={{ color: "red" }}>X</span>}
      >
        <div className="modal-body mt-5">
          <div className="profile-image text-center mt-4 mb-4">
            <img
              src={AllFormsUpperphoto}
              alt="Profile"
              className="img-fluid rounded-circle"
              style={{ width: "100px", height: "100px" }}
            />
          </div>
          <form>
            <div className="row">
              <div className="col-md-6">
                <div className="input-block mb-3">
                  <label className="col-form-label">
                    Branch <span className="text-danger">*</span>
                  </label>
                  <select
                    className="form-control"
                    value={LocalFormData.BranchId}
                    onChange={(e) =>
                      setLocalFormData({
                        ...LocalFormData,
                        BranchId: e.target.value,
                      })
                    }
                  >
                    <option value="">Select Branch</option>
                    {allbranch &&
                      allbranch.length > 0 &&
                      allbranch.map((res) => (
                        <option value={res.id}>{res.name}</option>
                      ))}
                    {/* Add more branches as needed */}
                  </select>
                </div>
              </div>
              <div className="col-md-6">
                <div className="input-block mb-3">
                  <label className="col-form-label">
                    Activity Type <span className="text-danger">*</span>
                  </label>
                  <select
                    className="form-control"
                    value={LocalFormData.ActivityId}
                    onChange={(e) =>
                      setLocalFormData({
                        ...LocalFormData,
                        ActivityId: e.target.value,
                      })
                    }
                  >
                    <option value="">Activity Type</option>
                    {MarketingActivityData &&
                      MarketingActivityData.length > 0 &&
                      MarketingActivityData.map((res) => (
                        <option value={res.id}>{res.name}</option>
                      ))}
                    {/* Add more branches as needed */}
                  </select>
                </div>
              </div>
              <div className="col-md-6">
                <label className="col-form-label">
                  Upload Document <span className="text-danger">*</span>
                </label>
                <input
                  className="form-control"
                  type="file"
                  accept="image/*"
                  ref={fileInputRef}
                  // value={LocalFormData.Selfie}
                  onChange={handleFileChange}
                />
              </div>
              <div className="col-md-6">
                <div className="input-block mb-3">
                  <label className="col-form-label">
                    Location Name <span className="text-danger">*</span>
                  </label>
                  <input
                    className="form-control"
                    type="text"
                    value={LocalFormData.Location}
                    onChange={(e) =>
                      setLocalFormData({
                        ...LocalFormData,
                        Location: e.target.value,
                      })
                    }
                  />
                </div>
              </div>
              {LocalFormData.IsContactNumbercollected === true && (
                <div className="col-md-6">
                  <div className="input-block mb-3">
                    <label className="col-form-label">
                      Count Of Contact Number Collected{" "}
                      <span className="text-danger">*</span>
                    </label>
                    <input
                      className="form-control"
                      type="number"
                      value={LocalFormData.Counts}
                      onChange={(e) =>
                        setLocalFormData({
                          ...LocalFormData,
                          Counts: e.target.value,
                        })
                      }
                    />
                  </div>
                </div>
              )}

              <div className="col-md-12">
                <label className="col-form-label">
                  Document Collected <span className="text-danger">*</span>
                </label>
                <div className="form-check">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="flexRadioDefault"
                    id="flexRadioDefault1"
                    value="true"
                    checked={LocalFormData.IsContactNumbercollected === true}
                    onChange={(e) =>
                      setLocalFormData({
                        ...LocalFormData,
                        IsContactNumbercollected: e.target.value === "true",
                      })
                    }
                  />
                  <label
                    className="form-check-label"
                    htmlFor="flexRadioDefault1"
                  >
                    yes
                  </label>
                </div>
                <div className="form-check">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="flexRadioDefault"
                    id="flexRadioDefault2"
                    value="false"
                    checked={LocalFormData.IsContactNumbercollected === false}
                    onChange={(e) =>
                      setLocalFormData({
                        ...LocalFormData,
                        IsContactNumbercollected: e.target.value === "true",
                      })
                    }
                  />
                  <label
                    className="form-check-label"
                    htmlFor="flexRadioDefault2"
                  >
                    No
                  </label>
                </div>
              </div>

              {/* Conditional rendering based on radio selection */}
            </div>
          </form>
        </div>
      </Modal>
    </>
  );
};
